import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import TeacherSidebar from "../../../components/gcstaff/staffsidebar/TeacherSidebar";
import TeacherTopbar from "../../../components/gcstaff/teachertopbar/TeacherTopbar";
import "../../../assets/css/gcstaff/staffmasterLayout/TeacherMasterLayout.css";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const MOBILE_BP = 992;

const TeacherMasterLayout = ({ children, pageTitle }) => {
  const navigate = useNavigate();
  const { setAuthToken, setLoggedInUser } = useContext(AppContext);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile,  setIsMobile]  = useState(window.innerWidth < MOBILE_BP);

  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < MOBILE_BP);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  /* ✅ Logout — student sidebar jesa same pattern */
  const handleLogout = () => {
        Swal.fire({
          title: "Logout?",
          text: "Are you sure you want to logout from Teacher Panel?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Logout",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#d63031",
          cancelButtonColor: "#1a5f7a",
        }).then((result) => {
          if (result.isConfirmed) {
            // Sab kuch clear karo
            localStorage.removeItem("authToken");
            localStorage.removeItem("userType");
            localStorage.removeItem("Teacher");
            localStorage.removeItem("TeacherEmail");
            localStorage.removeItem("TeacherPassword");
    
            // Context bhi reset karo
            if (setAuthToken)    setAuthToken(null);
            if (setLoggedInUser) setLoggedInUser(null);
    
            navigate("/");
          }
        });
      };

  const mainClass = [
    "gcTeacher-layout__main",
    !isMobile && collapsed ? "gcTeacher-layout__main--collapsed" : "",
    isMobile               ? "gcTeacher-layout__main--mobile"    : "",
  ].filter(Boolean).join(" ");

  return (
    <div className="gcTeacher-layout">
      <TeacherSidebar
        onCollapsedChange={setCollapsed}
        onLogout={handleLogout}
      />
      <div className={mainClass}>
        <TeacherTopbar
          title={pageTitle || "Teacher Control Panel"}
          collapsed={collapsed}
        />
        {children}
      </div>
    </div>
  );
};

export default TeacherMasterLayout;